import Vue from "vue";
/**
 * 获取当前模块的表头菜单数据
 */
export function getTableMenu(active) {
  let menu = [];
  switch (active) {
    case "humanMine":
    // 我的人才
    case "humanBase":
      // 人才库
      menu = [
        { name: "姓名", key: "name", authority: "1" },
        { name: "联系电话", key: "phone", authority: "1" },
        { name: "地区", key: "address", authority: "1" },
        { name: "证书及专业", key: "certificateTYype", authority: "1" },
        { name: "身份证", key: "idCard", authority: "1" },
        { name: "最新联系时间", key: "latestContactTime", authority: "1" },
        { name: "是否聘用", key: "isEngage", authority: "1" },
      ];
      break;
    default:
      break;
  }
  return menu;
}

/**
 * 获取工资单表头菜单数据
 */
export function getHumanPayrollSettingMenuData() {
  let menu = [
    {
      label: "月份",
      prop: "date",
      fixed: true,
      width: 100,
    },
    {
      label: "基本工资",
      prop: "basicPay",
      remark: "basicPayRemark",
      width: 100,
    },
    {
      label: "岗位工资",
      prop: "postWage",
      remark: "postWageRemark",
      width: 100,
    },
    {
      label: "绩效工资",
      prop: "meritPay",
      remark: "meritPayRemark",
      width: 100,
    },
    {
      label: "绩效提成",
      prop: "meritCommission",
      remark: "meritCommissionRemark",
      width: 100,
    },
    {
      label: "交付提成",
      prop: "deliveryCommission",
      remark: "deliveryCommission",
      width: 100,
    },
    {
      label: "业务提成",
      prop: "businessCommission",
      remark: "businessCommissionRemark",
      width: 100,
    },
    {
      label: "业务提成 (增减) ",
      prop: "businessCommissionIncOrDec",
      remark: "businessCommissionIncOrDecRemark",
      width: 120,
    },
    {
      label: "奖金",
      prop: "bonus",
      remark: "bonusRemark",
      width: 100,
    },
    {
      label: "津贴补助",
      prop: "subsidy",
      remark: "subsidyRemark",
      width: 100,
    },
    {
      label: "考勤扣款",
      prop: "attendanceDeduction",
      remark: "attendanceDeductionRemark",
      width: 100,
    },
    {
      label: "个税",
      prop: "individualIncomeTax",
      remark: "individualIncomeTaxRemark",
      width: 100,
    },
    {
      label: "五险代扣合计",
      prop: "socialSecurityWithholding",
      remark: "socialSecurityWithholdingRemark",
      width: 120,
    },
    {
      label: "累计工资收入",
      prop: "wageIncome",
      remark: "wageIncomeRemark",
      width: 120,
    },
    {
      label: "扣除总计",
      prop: "deductTotal",
      remark: "deductTotalRemark",
      width: 100,
    },
    {
      label: "实发工资",
      prop: "netPayroll",
      remark: "netPayrollRemark",
      width: 100,
    },
    {
      label: "扣分",
      prop: "deductionOfPoints",
      remark: "deductionOfPointsRemark",
      width: 60,
    },
    {
      label: "所在公司",
      prop: "company",
      remark: "",
      width: 150,
    },
    {
      label: "入职时间",
      prop: "entryDate",
      remark: "",
      width: 100,
    },
    {
      label: "离职时间",
      prop: "resignDate",
      remark: "",
      width: 100,
    },
    {
      label: "备注",
      prop: "remark",
      remark: "",
      width: 100,
    },
  ];
  return menu;
}

export function humanDrawerData(title, authorityData, isHead, options, flag) {
  let threadDrawerData = getDrawerData(title, options, flag);

  // 拼接数据显示权限
  threadDrawerData =
    Vue.prototype.$initDrawerAuthorityData.initDrawerAuthorityData(
      threadDrawerData,
      authorityData,
      isHead,
    );

  return threadDrawerData;
}

function getDrawerData(title, options, flag) {
  let humanDrawerData = {
    data: {
      modelList: [],
    },
  };
  switch (flag) {
    case "人才信息":
      humanDrawerData = {
        title: "人才信息",
        flag: false,
        CardList: [
          {
            text: "人才信息",
            active: "info",
            key: "",
          },
          {
            text: "需求",
            active: "requirements",
          },
          {
            text: "附件",
            active: "attachment",
          },
        ],
        cardIndex: 0,
        buttonList: [
          {
            text: "跟进",
            icon: "el-icon-edit-outline",
            active: "genjin",
            key: "followUp",
          },
        ],
        hasSetting: true,
        settingOperList: [
          {
            text: "删除人才",
            active: "delete_client",
            key: "delete",
          },
          {
            text: "申请客户流失",
            active: "run_off",
            key: "lossOf",
          },
          {
            text: "添加关联客户",
            authority: 1,
            active: "adding_associated_customer",
            key: "associat",
          },
          {
            text: "操作记录",
            active: "operating_record",
            key: "cancel",
          },
        ],
        data: {},
      };
      break;
    case "简历库":
      console.log("简历库简历库简历库简历库简历库");
      humanDrawerData = {
        title: "简历信息",
        flag: false,
        hasSetting: true,
        status: "", // 当前商机状态
        settingOperList: [],
        buttonList: [],
        data: {
          title: title,
          titleEdit: false,
          isDisable: true, // 是否只读
          modelList: [
            {
              line: [
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "姓名",
                  key: "name",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "创建日期",
                  key: "gmtCreate",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "面试官",
                  key: "interviewerName",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "面试时间",
                  key: "interviewTime",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "待入职时间",
                  key: "entryDate",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "应聘部门",
                  key: "departmentAppliedName",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "应聘职位",
                  key: "positionApplied",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "简历来源",
                  key: "talentSource",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "入库原因",
                  key: "reasonForStorage",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "能力判定",
                  key: "abilityJudgment",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "手机号",
                  key: "phone",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "微信号",
                  key: "wechat",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "在职状态",
                  key: "inductionStatus",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "备注",
                  key: "remark",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "是否跟进",
                  key: "isGenJin",
                  type: "radio",
                  value: 0,
                  options: [
                    {
                      text: "是",
                      label: 1,
                    },
                    {
                      text: "否",
                      label: 0,
                    },
                  ],
                },
              ],
            },
            {
              line: [
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "",
                  key: "workExperience", // 工作经历
                  type: "interviewCompanyRecord",
                  value: "",
                },
              ],
            },
            {
              line: [
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "",
                  key: "interviewRecord", // 面试经历
                  type: "interviewRecord",
                  value: "",
                },
              ],
            },
            {
              line: [
                {
                  horizontal: false,
                  isShow: false,
                  isDisable: false,
                  title: "", // 简历记录
                  type: "projectRecord",
                  value: "",
                  key: "resumeRecord",
                },
              ],
            },
          ],
        },
      };
      break;
    case "员工信息":
      humanDrawerData = {
        title: "员工信息",
        flag: false,
        hasSetting: true,
        status: "", // 当前商机状态
        settingOperList: [],
        buttonList: [],
        data: {
          title: title,
          titleEdit: false,
          isDisable: true, // 是否只读
          modelList: [
            {
              line: [
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "姓名",
                  key: "name",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "性别",
                  key: "sex",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "年龄",
                  key: "age",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "学历",
                  key: "qualification",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "出生日期",
                  key: "birthday",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "手机号",
                  key: "phone",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "身份证号",
                  key: "idCard",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "银行卡号",
                  key: "bankCard",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "户籍所在地",
                  key: "domicile",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "现居地址",
                  key: "address",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "紧急联系人1",
                  key: "firstEmergencyContact",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "紧急联系人2",
                  key: "secondEmergencyContact",
                  type: "text",
                  value: "",
                },
              ],
            },
            {
              line: [
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "部门",
                  key: "activeDepartmentName",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "岗位",
                  key: "activePost",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "职级",
                  key: "jobGrade",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "薪资",
                  key: "salary",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "合同主体",
                  key: "subjectOfContract",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "合同到期时间",
                  key: "contractExpirationDate",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "是否购买社保",
                  key: "socialSecurityPurchaseName",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "社保购买时间",
                  key: "socialSecurityPurchaseDate",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "是否转正",
                  key: "isRegularizedName",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "转正时间",
                  key: "regularizationDate",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "入职时间",
                  key: "entryDate",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true, // 是否显示
                  isDisable: false, // 是否只读
                  title: "离职时间",
                  key: "resignDate",
                  type: "text",
                  value: "",
                },
              ],
            },
          ],
        },
      };
      break;
    default:
      break;
  }
  return humanDrawerData;
}

export function returnDrawerKeys(model, flag) {
  let keys = [];
  let drawerData = getDrawerData(
    "",
    Vue.prototype.$tagData.getDrawerOptionsList(model),
    flag,
    {},
  ).data.modelList;
  for (let index = 0; index < drawerData.length; index++) {
    let element = drawerData[index].line;
    for (let i = 0; i < element.length; i++) {
      let ele = element[i];
      if (ele.key) {
        let dd = {
          name: ele.text,
          key: ele.key,
          authority: "1",
          sequence: 1,
          id: "",
        };
        keys.push(JSON.parse(JSON.stringify(dd)));
      }
    }
  }
  console.log("keys", keys);
  return keys;
}

/**
 * 获取新增, 编辑dialog数据
 * @employeeList 人员列表 带权限
 * @data 表格当前行数据
 */
export function getHumanDialogData(staffList, data) {
  let dialogData = {
    id: data.id,
    staffList,
    employeeId: data.employeeId,
    date: data.date,
    remark: data.remark,
    basicPay: data.basicPay, // 基本工资
    basicPayRemark: data.basicPayRemark, // 基本工资备注
    postWage: data.postWage, // 岗位工资
    postWageRemark: data.postWageRemark, // 岗位工资备注
    meritPay: data.meritPay, // 绩效工资
    meritPayRemark: data.meritPayRemark, // 绩效工资备注
    meritCommission: data.meritCommission, // 绩效提成
    meritCommissionRemark: data.meritCommissionRemark, // 绩效提成备注
    businessCommissionIncOrDec: data.businessCommissionIncOrDec, // 业务提成
    businessCommissionIncOrDecRemark: data.businessCommissionIncOrDecRemark, // 业务提成备注
    bonus: data.bonus, // 奖金
    bonusRemark: data.bonusRemark, // 奖金备注
    subsidy: data.subsidy, // 津贴补助
    subsidyRemark: data.subsidyRemark, // 津贴补助备注
    attendanceDeduction: data.attendanceDeduction, // 考勤扣款
    attendanceDeductionRemark: data.attendanceDeductionRemark, // 考勤扣款备注
    individualIncomeTax: data.individualIncomeTax, // 个税
    individualIncomeTaxRemark: data.individualIncomeTaxRemark, // 个税备注
    socialSecurityWithholding: data.socialSecurityWithholding, // 五险代扣合计
    socialSecurityWithholdingRemark: data.socialSecurityWithholdingRemark, // 五险代扣合计备注
    wageIncome: data.wageIncome, // 累计工资收入
    wageIncomeRemark: data.wageIncomeRemark, // 累计工资收入备注
    deductTotal: data.deductTotal, // 扣除总计
    deductTotalRemark: data.deductTotalRemark, // 扣除总计备注
    netPayroll: data.netPayroll, // 实发工资
    netPayrollRemark: data.netPayrollRemark, // 实发工资备注
    deductionOfPoints: data.deductionOfPoints, // 扣分
    deductionOfPointsRemark: data.deductionOfPointsRemark, // 扣分备注
    company: data.company, // 所在公司
    remark: data.remark, // 所在公司
  };
  return dialogData;
}

/**
 * 导入税务详情数据
 */
export function importHumanDialogData(this_) {
  return [
    {
      title: "选择月份",
      type: "time_month",
      value: "",
    },
    {
      type: "improt_resources",
      value: {
        url: "",
        text: "",
        action: this_.$fileBaseurl + "/uploadImageByMultipartFile",
        uploadParameter: {
          systemName: "finance",
          title: "导入工资单",
        },
        headers: {
          token: "95931b371eb64f4a9c862983ca8a5d15",
        },
        modelType: "payrollMode",
      },
    },
  ];
}

/**
 * 获取业绩提成表的菜单数据
 */
export function getHumanPerformanceMenuData() {
  return [
    {
      prop: "assistUserName",
      title: "协助人员",
      width: "120",
    },
    {
      prop: "clientName",
      title: "公司名称",
      width: "",
    },
    {
      prop: "userName",
      title: "签单人员",
      width: "120",
    },
    {
      prop: "contractNumber",
      title: "合同编号",
      width: "140",
    },
    {
      prop: "serveItem",
      title: "服务项目",
      width: "120",
    },
    {
      prop: "money",
      title: "签约金额",
      width: "80",
    },
    {
      prop: "cost",
      title: "成本",
      width: "80",
    },
    {
      prop: "accountingCost",
      title: "核算成本",
      width: "80",
    },
    {
      prop: "expenditureCost",
      title: "支出成本",
      width: "80",
    },
    {
      prop: "paymentCollect",
      title: "收款金额",
      width: "80",
    },
    {
      prop: "amountsOw",
      title: "未回款额",
      width: "80",
    },
    {
      prop: "profits",
      title: "毛利润",
      width: "80",
    },
    {
      prop: "royaltyProfit",
      title: "提成利润",
      width: "80",
    },
    {
      prop: "royaltyRate",
      title: "提成比例",
      width: "80",
    },
    {
      prop: "royalty",
      title: "提成",
      width: "80",
    },
  ];
}

export function getHumanPerformanceDialogMenuData() {
  return [
    {
      prop: "userName",
      title: "姓名",
      width: "120",
    },
    {
      prop: "clientName",
      title: "公司名称",
      width: "",
    },
    {
      prop: "contractNumber",
      title: "合同编号",
      width: "140",
    },
    {
      prop: "serveItem",
      title: "服务项目",
      width: "120",
    },
    {
      prop: "money",
      title: "签约金额",
      width: "80",
    },
    {
      prop: "cost",
      title: "成本",
      width: "80",
    },
    {
      prop: "accountingCost",
      title: "核算成本",
      width: "80",
    },
    {
      prop: "expenditureCost",
      title: "支出成本",
      width: "80",
    },
    {
      prop: "paymentCollect",
      title: "收款金额",
      width: "80",
    },
    {
      prop: "amountsOw",
      title: "未回款额",
      width: "80",
    },
    {
      prop: "profits",
      title: "毛利润",
      width: "80",
    },
    {
      prop: "royaltyProfit",
      title: "提成利润",
      width: "80",
    },
    {
      prop: "royaltyRate",
      title: "提成比例",
      width: "80",
    },
    {
      prop: "royalty",
      title: "提成",
      width: "80",
    },
  ];
}

/**
 * 获取业绩提成表的菜单数据 详情
 */
export function getHumanDispatchMenuData() {
  return [
    {
      prop: "completeUserName",
      updateKey: "completeUserId",
      title: "执行人",
      width: "140",
    },
    {
      prop: "clientName",
      title: "客户名称",
      width: "",
    },
    {
      prop: "serviceItem",
      title: "服务项",
      width: "110",
    },
    {
      prop: "productName",
      title: "服务产品",
      width: "130",
    },
    {
      prop: "stepName",
      title: "完成步骤",
      width: "200",
    },
    {
      prop: "currentStepTime",
      title: "完成步骤时间",
      width: "150",
    },
    {
      prop: "commission",
      title: "步骤提成",
      width: "120",
    },
    {
      prop: "status",
      title: "派工完成情况",
      width: "",
    },
  ];
}

/**
 * 获取业绩提成表的菜单数据 统计
 */
export function getHumanDispatchMenuData2() {
  return [
    {
      prop: "completeUserName",
      title: "姓名",
      width: "",
    },
    {
      prop: "totalCommission",
      title: "提成合计",
      width: "",
    },
    {
      prop: "royaltyRate",
      title: "提成比率",
      width: "",
    },
    {
      prop: "totalRoyalty",
      title: "提成金额",
      width: "",
    },
  ];
}

/**
 * 获取交付提成表的菜单数据 详情
 */
export function getHumanContractMenuData() {
  return [
    {
      prop: "commissionUserName",
      title: "姓名",
      width: "",
    },
    {
      prop: "clientName",
      title: "客户名称",
      width: "160",
    },
    {
      prop: "contractNumber",
      title: "合同编号",
      width: "",
    },
    {
      prop: "completedStatus",
      title: "完成状态",
      width: "90",
    },
    {
      prop: "reviewStatus",
      title: "审核状态",
      width: "90",
    },
    {
      prop: "receiptsStatus",
      title: "收款状态",
      width: "90",
    },
    {
      prop: "amount",
      title: "合同金额",
      width: "110",
      type: "input",
    },
    {
      prop: "contractCycle",
      title: "合同周期(月)",
      width: "100",
    },
    {
      prop: "contractAverageRoyalty",
      title: "合同月均提成",
      width: "120",
    },
    {
      prop: "commissionRatio",
      title: "提成比率",
      width: "100",
      type: "input",
      icon: "%",
      bath: true,
    },
    {
      prop: "commissionAmount",
      title: "提成金额",
      width: "",
    },
    // {
    //   prop: "commissionRatio",
    //   title: "提成比率",
    //   width: "120",
    // },
  ];
}

/**
 * 获取交付提成表的菜单数据 统计
 */
export function getHumanContractMenuData2() {
  return [
    {
      prop: "userName",
      title: "姓名",
      width: "",
    },
    {
      prop: "royalty",
      title: "总提成金额",
      width: "",
    },
  ];
}

// 简历库抽屉数据模板
export function getDrawerDataByHumanResume(
  title,
  authorityData,
  isHead,
  options,
) {
  // 定义线索分配抽屉数据
  let humanResumeDrawerData = {};
}

// 员工信息抽屉数据模板
export function getDrawerDataByHumanEmployee(
  title,
  authorityData,
  isHead,
  options,
) {
  // 定义线索分配抽屉数据
  let humanResumeDrawerData = {};

  return humanResumeDrawerData;
}

// 企业信息 关联公司表头数据
export function humanCheckDialogTable() {
  return [
    {
      prop: "approvalNumber",
      label: "审批编号",
      type: "text",
      width: "115px",
    },
    {
      prop: "type",
      label: "请假类型",
      type: "text",
      width: "80px",
    },
    {
      prop: "startTime",
      label: "开始时间",
      type: "text",
      width: "125px",
    },
    {
      prop: "endTime",
      label: "结束时间",
      type: "text",
      width: "125px",
    },
    {
      prop: "duration",
      label: "请假时长(天)",
      type: "text",
      width: "110px",
    },
    {
      prop: "approvalStatus",
      label: "审批状态",
      type: "text",
      width: "80px",
    },
    {
      prop: "reason",
      label: "请假事由",
      type: "text",
    },
    {
      label: "操作",
      type: "buts",
      width: "145px",
      buts: [
        {
          name: "编辑",
          type: "primary",
          active: "edit",
        },
        {
          name: "删除",
          type: "danger",
          active: "delete",
        },
      ],
    },
  ];
}

export function serviceNameList() {
  return [
    {
      label: "税所服务",
      value: "税所服务",
    },
    {
      label: "记账报税",
      value: "记账报税",
    },
    {
      label: "项目申报",
      value: "项目申报",
    },
    {
      label: "短期交付",
      value: "短期交付",
    },
  ];
}

//
/**
 * 员工信息弹窗数据模板
 * @param {*} row 员工信息数据
 * @param {*} tagList 标签数据
 * @param {*} _this  this 指向
 */
export function humanEmployeeDialogData(row, tagList, _this) {
  console.log("row", row);

  return [
    {
      width: "100%",
      type: "line-text",
      text: "基础信息",
    },
    {
      width: "45%",
      type: "autocomplete",
      title: "姓名",
      key: "name",
      required: true,
      value: row ? row.name : "",
    },
    {
      width: "45%",
      type: "input",
      title: "工号",
      key: "jobNumber",
      value: row ? row.jobNumber : "",
    },
    {
      width: "45%",
      type: "radio",
      title: "性别",
      key: "sex",
      required: true,
      value: row ? row.sex : "男",
      options: [
        {
          label: "男",
          value: "男",
        },
        {
          label: "女",
          value: "女",
        },
      ],
    },
    {
      width: "45%",
      type: "select",
      title: "学历",
      key: "qualification",
      required: true,
      value: row ? row.qualification : "",
      options: tagList.qualificationList,
    },
    {
      width: "45%",
      type: "time_date",
      title: "出生日期",
      key: "birthday",
      required: true,
      value: row ? row.birthday : "",
    },
    {
      width: "45%",
      type: "input",
      title: "身份证号",
      key: "idCard",
      required: true,
      value: row ? row.idCard : "",
    },
    {
      width: "45%",
      type: "input-number2",
      title: "手机号",
      key: "phone",
      required: true,
      value: row ? row.phone : "",
    },
    {
      width: "45%",
      type: "textarea",
      title: "户口所在地",
      key: "domicile",
      value: row ? row.domicile : "",
      rows: 2,
    },
    {
      width: "45%",
      type: "textarea",
      title: "现居地址",
      key: "address",
      value: row ? row.address : "",
      rows: 2,
    },
    {
      width: "100%",
      type: "line-text",
      text: "岗位信息",
    },
    {
      width: "22%",
      type: "input-number2",
      title: "基本工资",
      key: "basicSalary",
      required: true,
      value: row ? row.basicSalary : "",
    },
    {
      width: "22%",
      type: "input-number2",
      title: "岗位工资",
      key: "positionSalary",
      required: true,
      value: row ? row.positionSalary : "",
    },
    {
      width: "22%",
      type: "input-number2",
      title: "绩效工资",
      key: "performanceSalary",
      required: true,
      value: row ? row.performanceSalary : "",
    },
    {
      width: "22%",
      type: "select",
      title: "职级",
      key: "jobGrade",
      required: true,
      value: row ? row.jobGrade : "",
      options: tagList.jobGradeList,
    },
    {
      width: "45%",
      type: "time_date",
      title: "入职日期",
      key: "entryDate",
      required: true,
      value: row.entryDate || _this.$dayjs().format("YYYY-MM-DD"),
    },
    {
      width: "45%",
      type: "input-number2",
      title: "银行卡号",
      key: "bankCard",
      required: true,
      value: row ? row.bankCard : "",
    },
    {
      width: "45%",
      type: "cascader-tree",
      title: "部门",
      key: "activeDepartment",
      required: true,
      value: row ? row.activeDepartment : "",
      options: tagList.allDepartTreeData,
      props: { value: "id", emitPath: false, checkStrictly: true },
    },
    {
      width: "45%",
      type: "select",
      title: "岗位",
      key: "activePost",
      required: true,
      value: row ? row.activePost : "",
      options: tagList.positionList,
    },
    {
      width: "45%",
      type: "select",
      title: "合同主体",
      key: "subjectOfContract",
      value: row ? row.subjectOfContract : "",
      options: tagList.subjectOfContractList,
    },
    {
      width: "45%",
      type: "time_date",
      title: "合同到期时间",
      key: "contractExpirationDate",
      value: row ? row.contractExpirationDate : "",
    },
    {
      width: "45%",
      type: "radio",
      title: "社保购买状态",
      key: "socialSecurityPurchase",
      required: true,
      value: row ? row.socialSecurityPurchase : "0",
      options: [
        {
          label: "是",
          value: "1",
        },
        {
          label: "否",
          value: "0",
        },
      ],
    },
    {
      width: "45%",
      type: "radio",
      title: "是否转正",
      key: "isRegularized",
      required: true,
      value: row ? row.isRegularized : "0",
      options: [
        {
          label: "是",
          value: "1",
        },
        {
          label: "否",
          value: "0",
        },
      ],
    },
    {
      width: "45%",
      type: "time_date",
      title: "社保购买时间",
      key: "socialSecurityPurchaseDate",
      value: row ? row.socialSecurityPurchaseDate : "",
    },
    {
      width: "45%",
      type: "time_date",
      title: "转正时间",
      key: "regularizationDate",
      value: row ? row.regularizationDate : "",
    },
    {
      width: "45%",
      type: "time_date",
      title: "离职时间",
      key: "resignDate",
      value: row ? row.resignDate : "",
    },
    {
      width: "100%",
      type: "line-text",
      text: "其他信息",
    },
    {
      width: "45%",
      type: "input",
      title: "紧急联系人1",
      key: "firstEmergencyContact",
      value: row ? row.firstEmergencyContact : "",
    },
    {
      width: "45%",
      type: "input",
      title: "紧急联系人2",
      key: "secondEmergencyContact",
      value: row ? row.secondEmergencyContact : "",
    },
    {
      width: "45%",
      title: "附件",
      key: "annex",
      type: "uploads",
      value: {
        value: row.annex || [],
        action: _this.$fileBaseurl + "/uploadImageByMultipartFile",
        headers: {
          token: "95931b371eb64f4a9c862983ca8a5d15",
        },
        uploadParameter: {
          systemName: "finance",
          title: "员工信息附件",
        },
      },
    },
  ];
}